import { Header } from '@components/Header';
import { PageErrorState } from '@components/core-ui/PageErrorState';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';

import { usePageContext } from '../../providers/PageProvider';
import { Pagination } from './components/Pagination';
import { Table } from './components/Table';
import { MainContent } from './styles/MainContent';

export const Content = () => {
  const { isExporting, isLoading, hasInitialError, retryUsers, search, setSearch, exportCSV } = usePageContext();

  return (
    <>
      <Header
        title="Admin Management"
        buttonLabel="Export CSV"
        buttonLoading={isExporting}
        buttonOnClick={exportCSV}
        setSearch={setSearch}
        search={search}
      />

      <LinearProgressLoader active={isLoading} />
      <MainContent>
        {hasInitialError ? (
          <PageErrorState
            message="Couldn't load admins"
            actionLabel="Retry"
            actionDisabled={isLoading}
            onAction={retryUsers}
          />
        ) : (
          <>
            <Table />
            <Pagination />
          </>
        )}
      </MainContent>
    </>
  );
};
